import { FlexProps } from '@chakra-ui/react'
import { SimpleFormFooter } from '../../../../components/forms'
import { useLaborCharting } from '../context'

const flexProps: FlexProps = {
  borderTop: '1px solid',
  borderColor: 'gray.200',
  bg: 'gray.100',
  _dark: { borderColor: 'gray.600', bg: 'gray.800' },
  w: '100%',
  px: 3,
  py: 1,
}
export const LaborEntryFooter = () => {
  const { deselectEntry } = useLaborCharting()
  return (
    <SimpleFormFooter
      flexProps={flexProps}
      onCancel={deselectEntry}
      submitText="Save"
      canSubmitClean
      submitCleanText="Save"
    />
  )
}
